import { forwardRef } from 'react';
import { useLazyImage } from '@/hooks';
import AvatarImage from './AvatarImage';

interface LazyAvatarImageProps {
	subcontractId?: number;
	name?: string;
	className?: string;
	size?: 'sm' | 'md' | 'lg';
	threshold?: number;
	rootMargin?: string;
}

const LazyAvatarImage = forwardRef<HTMLDivElement, LazyAvatarImageProps>(
	({ subcontractId, name, className, size, threshold = 0.1, rootMargin = '50px' }, ref) => {
		const { ref: lazyRef, isInView } = useLazyImage({
			threshold,
			rootMargin,
			triggerOnce: true,
		});

		return (
			<div ref={ref}>
				<div ref={lazyRef}>
					{isInView ? (
						<AvatarImage
							subcontractId={subcontractId}
							name={name}
							className={className}
							size={size}
						/>
					) : (
						<div className={`${className} bg-gray-200 animate-pulse rounded-full`} />
					)}
				</div>
			</div>
		);
	},
);

LazyAvatarImage.displayName = 'LazyAvatarImage';

export default LazyAvatarImage;
